import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykzvzt6ka3: FaireProductEntity = {
  token: "p_ykzvzt6ka3",
  type: "product",
  name: "manger baby sticker",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/63ea9c500c8ec55a1aa3ee678167a6f269f81deb6c2b60435de8d73c8ca29b6b.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'Add this sticker to your water bottle, laptop, journal, envelopes, and more.\n\n• vinyl sticker\n• 3" x 3"\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:11.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
